export const comments_3389028 = {"data":{"data":[],"links":{}}}